import { START_AUTHENTICATION } from '../constants/actionTypes';

const startAuthentication = () => {
  return {
    type: START_AUTHENTICATION,
  };
};

export default startAuthentication;
